// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4cb5f514","453":"7c67aa7f","667":"3db82634","977":"82f3a636"}[chunkId] + ".chunk.js";
};